export default {"src":"/_next/static/media/chevron-down-circle-fill.b23dc333.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};